import React from "react";
import AssessorView from "./views/parts/AssessorView";
import AssesseeView from "./views/parts/AssesseeView";
import useDataSession from "../SessionMethodVideoModul/customeHooks/useDataSession";
import { UI_MODE } from "../../general/constants/uiModeConstans";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const view = (key) => {
  switch (key) {
    case "ASSESSOR":
      return <AssessorView />;
    case "ASSESSEE":
      return <AssesseeView />;
    default:
      break;
  }
};

// need type assessor or assessee
// conect to web socket
// navigate to live when room is open

export default function WaitingRoomModul() {
  const { dataSession, session } = useDataSession();
  const storeOpenSession = useSelector((state) => state.wsmodul_status);

  return (
    <>
      {view(dataSession.user?.type)}
      {storeOpenSession.success == true && (
        <Navigate
          to={
            "/Live/" + UI_MODE(dataSession.sessionInfo?.uiMode) + "/" + session
          }
        />
      )}
    </>
  );
}
